import { useContext } from "react"
import { HeaderContext } from "~/context/HeaderContext"

export default function useHeaderHeightSpace(): number {
  const context = useContext(HeaderContext)

  return Math.round(context.headerHeight / 4) / 2
}
